import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { OrganizationMemberInvitationSteps } from '../../enums/organization-member-invitation-steps';
import { MarkantElementsModule } from '@markant/elements-angular';

@Component({
  selector: 'markant-platform-organization-member-invitation-step-header',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, MarkantElementsModule],
  templateUrl: './organization-member-invitation-step-header.component.html',
  styleUrl: './organization-member-invitation-step-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationMemberInvitationStepHeaderComponent implements OnChanges {
  @Input({ required: true }) step!: OrganizationMemberInvitationSteps;

  translationPath = '';
  showInfoNotice = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['step']) {
      switch (this.step) {
        case OrganizationMemberInvitationSteps.USER:
          this.translationPath = 'organization.users.invite.userView.';
          this.showInfoNotice = false;
          break;
        case OrganizationMemberInvitationSteps.ROLE:
          this.translationPath = 'organization.users.invite.roleView.';
          this.showInfoNotice = false;
          break;
        case OrganizationMemberInvitationSteps.GROUP:
          this.translationPath = 'organization.users.invite.groupView.';
          this.showInfoNotice = false;
          break;
        case OrganizationMemberInvitationSteps.CARTRIDGE:
          this.translationPath = 'organization.users.invite.cartridgeView.';
          this.showInfoNotice = true;
          break;
      }
    }
  }
}
